<template>
  <div>
    <div class="fast-modal-content">
      <!-- input is used for matomo analytics -->
      <input ref="input" hidden type="text" :name="itemType" />

      <Teleport to="#fast-title">{{ stepTitle }}</Teleport>
      <div class="fast-modal-btns">
        <ButtonSelect
          v-for="item in list"
          :key="item.id"
          :identifier="item.id"
          :label="item.name"
          :selected="selectedItem === item.id"
          @click="handleClick(item.id)"
        />
      </div>
    </div>
    <StepsNavigation
      :next-step-disabled="selectedItem === null || selectedItem === ''"
      @prevStep="handlePrevStep"
      @nextStep="handleNextStep"
    />
  </div>
</template>

<script>
import stepEvents from '../mixins/stepEvents'
import ButtonSelect from './ButtonSelect.vue'
import StepsNavigation from './StepsNavigation.vue'

export default {
  name: 'StepSelect',
  components: {
    ButtonSelect,
    StepsNavigation
  },
  mixins: [stepEvents],
  props: {
    stepTitle: {
      type: String,
      required: true
    },
    list: {
      type: Array,
      required: true
    },
    itemType: {
      type: String,
      required: true
    },
    selectedItem: {
      type: String,
      required: true
    }
  },
  mounted() {
    this.$refs.input.value = this.selectedItem
  },
  methods: {
    handleClick(id) {
      this.$refs.input.value = id
      this.$emit('attributeChange', this.itemType, id)
      this.$emit('nextStep')
    }
  }
}
</script>
